export default function PlanificationJobPrefacturationsConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('planification.job.prefacturations');
}

PlanificationJobPrefacturationsConfiguration.$inject = ['$translatePartialLoaderProvider'];
